// extracted by mini-css-extract-plugin
export default {"rgMain":"ymuygNkWFrww82ALfHP4","wrapper":"b9uB5r_4BaKen7D_mB1T","heroSectionWrap":"JJY1MBuh1Bd2j3U0QJtx","lightLinks":"Dled5HA8BrK9giotwU4w","goldBullets":"YiEWWQ6YIyOfiX1ntKM5","rowArticle":"Ldi2AkS1JYmQpGH0FaCQ","child":"v2Lc3Nh35lhaSLdWaIIq","subGuidelinesWrap":"P2veLkVOWQCJkVj2BDFh","reorder":"sUl39SoHKEHGe3t77ncB"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"rgMain\":\"ymuygNkWFrww82ALfHP4\",\"wrapper\":\"b9uB5r_4BaKen7D_mB1T\",\"heroSectionWrap\":\"JJY1MBuh1Bd2j3U0QJtx\",\"lightLinks\":\"Dled5HA8BrK9giotwU4w\",\"goldBullets\":\"YiEWWQ6YIyOfiX1ntKM5\",\"rowArticle\":\"Ldi2AkS1JYmQpGH0FaCQ\",\"child\":\"v2Lc3Nh35lhaSLdWaIIq\",\"subGuidelinesWrap\":\"P2veLkVOWQCJkVj2BDFh\",\"reorder\":\"sUl39SoHKEHGe3t77ncB\"}";
        // 1755964981069
        var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  